<sd-modal data-analytics="mobile-datepicker">
  <div class="cx-dialog-header modal-header">
    <div class="cx-dialog-title modal-title">Другой день</div>
  </div>

  <div class="cx-dialog-body pt-4 facet-block">
    <div class="wrapper">
      <ngb-datepicker
        #dp
        (dateSelect)="onSelectAnotherDateNgb($event)"
        [minDate]="minDate$ | async"
        [maxDate]="maxDate$ | async"
        [markDisabled]="markDisabled"
        navigation="arrows"
      ></ngb-datepicker>
    </div>
  </div>
</sd-modal>
